import { TeacherClassRecord } from './teacher/TeacherClassRecord';
import { TeacherPersonRecord } from './teacher/TeacherPersonRecord';
import { TeacherAllRecords } from './teacher/TeacherAllRecords';

import { PersonaSwitcher } from '../../../components/PersonaSwitcher';

const ClassRecord = () =>
  <PersonaSwitcher
      adminView={<TeacherClassRecord />}
      teacherView={<TeacherClassRecord />}
  />

const PersonRecords = () =>
  <PersonaSwitcher
      adminView={<TeacherPersonRecord />}
      teacherView={<TeacherPersonRecord />}
  />

const AllRecords = () =>
  <PersonaSwitcher
      adminView={<TeacherAllRecords />}
      teacherView={<TeacherAllRecords />}
  />

export { ClassRecord, PersonRecords, AllRecords };
